export default __webpack_public_path__ + "static/media/13.25c05944.png";